<template>
  <div>
    <pcbind @closeBindDialog="closeBindDialog" v-if="bindIshow"></pcbind>
  </div>
</template>

<script>
export default {
  name: '',
  data() {
    return {
      bindIshow:true
    }
  },
  computed: {},
  watch: {},
  created() {

  },
  methods: {
    closeBindDialog(){
      this.bindIshow = false
    }
  }
}
</script>

<style lang="less" scoped></style>
